import {API} from "../api";
import {IBundle} from "./BundleData";
import {IBadgable} from "./entities/IBadgable";
import {deleteCookie, getCookie} from "../utils";
import {action, computed, observable} from "mobx";


export type SolutionTypeType = 'challenge'|'health fair'|'webinar'|'cooking class'|'library'|'videos'|'company booth'|'dashboard link'|'onsite health fair';

export const SolutionType: { [key: string]: SolutionTypeType } = {
	CHALLENGE:'challenge',
	HEALTH_FAIR:'health fair',
	WEBINAR:'webinar',
	COOKING_CLASS:'cooking class',
	LIBRARY:'library',
	VIDEOS:'videos',
	COMPANY_BOOTH:'company booth',
	DASHBOARD_LINK:'dashboard link',
	ONSITE_HEALTH_FAIR:'onsite health fair',
}

export interface ISolutionBundle {
	_id:string;
	bundleId: string;
	bundleName: string;
	order: number;
	checkInSecret: string;
	checkInPointValue: number;
	checkInLocksContent: boolean;
	unlockPointValue: number;
	dateOfEvent: Date;
	bundleType:string;
}

export interface ISolution extends IBadgable {
	_id:string;
	alwaysAvailable:boolean;
	badge:string;
	badgePreview:string;
	badgeEarned:boolean;
	badgeUsed:string;
	badgeThreshold:number;
	badgeInstructions:string;
	closeDate:Date;
	commentPeriodHasEnded:boolean;
	icon:string;
	introduction:string;
	logo:string;
	name:string;
	openDate:Date;
	overview:string;
	photo:string;
	pointsOverview:string;
	practitioner:string;
	programParagraph1:string;
	programParagraph2:string;
	regDetailsParagraph1:string;
	regDetailsParagraph2:string;
	regHeadline:string;
	registrationBegins:Date;
	registrationEnds:Date;
	solutionLogo:string;
	type:SolutionTypeType;
	visibleDate:Date;
	subTitle:string;
	bundles:IBundle[];
	prizesHeadline: string;
	prizesPageName: string;
	prizesDescription: string;
	prizes:any[];
	customPages:any[];
	vendorBoothsNavLabel: string;
	vendorBoothsDisplayFirst: boolean;
	vendorBoothsEnabled: boolean;
	solutionBundles:ISolutionBundle[];
	autoRegister: boolean;
}

type IBoothCheckInResponseType = 'success'|'solution not open'|'already checked in'|'not found'|'passcode incorrect'|'unknown failure'|'passcode empty';
export const CHECK_IN_RESPONSE_STATUS_SUCCESS:IBoothCheckInResponseType = 'success';
export const CHECK_IN_RESPONSE_SOLUTION_NOT_OPEN:IBoothCheckInResponseType = 'solution not open';
export const CHECK_IN_RESPONSE_STATUS_ALREADY_CHECKED_IN:IBoothCheckInResponseType = 'already checked in';
export const CHECK_IN_RESPONSE_STATUS_PASSCODE_INCORRECT:IBoothCheckInResponseType = 'passcode incorrect';
export const CHECK_IN_RESPONSE_STATUS_PASSCODE_EMPTY:IBoothCheckInResponseType = 'passcode empty';
export const CHECK_IN_RESPONSE_STATUS_NOT_FOUND:IBoothCheckInResponseType = 'not found';
export const CHECK_IN_RESPONSE_STATUS_UNKNOWN_FAILURE:IBoothCheckInResponseType = 'unknown failure';

interface IBoothCheckInResponse {
	statusCode:IBoothCheckInResponseType,
	solutionName:string,
	solutionBundle:ISolutionBundle|null,
	feedItem?:any,
}

class SolutionDataSource {

	@observable checkInResponse:IBoothCheckInResponse|null;
	@computed get showCheckInConfetti() {
		return null!=this.checkInResponse;
	}
	@action handleCheckInAttempt(checkInResponse:IBoothCheckInResponse) {
		this.checkInResponse = checkInResponse;
	}
	@action hideCheckInConfetti = () => {
		this.checkInResponse = null;
	}

	checkInToOnsiteBoothFromCookies = () => {
		const solutionId = getCookie("checkin-sid", true);
		const bundleId = getCookie("checkin-bid", true);
		const secret = getCookie("checkin-secret", true);
		return this.checkInToOnsiteBooth(solutionId, bundleId, secret);
	}

	checkInToOnsiteBooth = (solutionId:string, bundleId:string, secret:string) => new Promise<any>((resolve)=> {
		if(solutionId && bundleId) {

				if(!secret || secret.trim().length===0){
					this.checkInResponse = {
						statusCode:CHECK_IN_RESPONSE_STATUS_PASSCODE_EMPTY,
						solutionName:'',
						solutionBundle:null,
					}
					resolve(null);

				} else {
					API.post('/on-site/check-in', {
						solutionId:solutionId,
						bundleId:bundleId,
						secret:decodeURI(secret),
					})
						.then(action((response:IBoothCheckInResponse)=>{
							this.checkInResponse = response;
							if(response.statusCode===CHECK_IN_RESPONSE_STATUS_SUCCESS){
								resolve(response);
							} else {
								resolve(null);
							}
						}))
						.catch(action(()=>{
							this.checkInResponse = {
								statusCode:CHECK_IN_RESPONSE_STATUS_UNKNOWN_FAILURE,
								solutionName:'',
								solutionBundle:null,
							}
							resolve(null);
						}));
				}


		} else {
			resolve(null);
		}
	});


	solutionForId = (id:string) => API.get('/solutions/'+id);

}


let solutionDataSource = new SolutionDataSource();
export { solutionDataSource };
